import React, {useState, useEffect} from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router"
import Sale from "../../components/forms/Sale/SaleForm"
const Payments = () => {
    const {user} = useSelector((state) => state.auth)
    const [option,setOption] = useState(<></>)
    const navigate = useNavigate()
    useEffect(() => {
        if(user.role === "Student" || user.role === "Parent"){
            setOption(<Sale />)
        }else{
            navigate("/")
        }
    }, [])
    return (
        <>  
            <br/>
            <h1>COMPRAS</h1>
            <br/>
            {option}
        </>
    )
}

export default Payments